<template>
  <div>
    <div class="flex flex-vertical-center mb-100">
      <div>
        <icon-default :icon="icon" color="is-light"></icon-default>
      </div>

      <div class="flex-grow ml-50">
        <button-link
          class="mb-25"
          @click="viewFollowUp"
          size=""
        >{{ templateLabel }}
        </button-link>

        <div class="flex flex-vertical-center">
          <p class="fus_item--subtitle">{{ subtitle }}</p>

          <button-link
            v-if="showPauseButton"
            class="ml-100"
            @click="pauseFollowUp"
            :disabled="isProcessing"
            :loading="isProcessing"
          >Pause
          </button-link>

          <button-link
            v-if="showResumeButton"
            class="ml-100"
            @click="resumeFollowUp"
            :disabled="isProcessing"
            :loading="isProcessing"
          >Resume
          </button-link>

          <button-link
            v-if="showCancelButton"
            class="ml-100"
            @click="cancelFollowUp"
            :disabled="isProcessing"
            :loading="isProcessing"
          >Cancel
          </button-link>
        </div>
      </div>
    </div>

    <modal-container>
      <!-- View Follow Up Modal -->
      <modal-default
        ref="viewFollowUpModal"
        :title="title"
      >
        <follow-up-view-info
          :follow-up="followUp"
        ></follow-up-view-info>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import TimelineEmail from "../../../components/timeline/TimelineEmail";
import FollowUpViewInfo from "./FollowUpViewInfo";
import dates from "../../../services/dates";

export default {
  name: "FollowUpItem",
  components: {FollowUpViewInfo, TimelineEmail},
  props: {
    followUp: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isProcessing: false,
    };
  },
  computed: {
    record() {
      return this.$store.state.activeRecord.record;
    },
    isActive() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Active.value;
    },
    isPaused() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Paused.value;
    },
    isCancelled() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Canceled.value;
    },
    isComplete() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Complete.value;
    },
    showPauseButton() {
      return this.isActive;
    },
    showResumeButton() {
      return this.isPaused;
    },
    showCancelButton() {
      return this.isActive || this.isPaused;
    },
    templateLabel() {
      const template = this.$store.getters.fusTemplates.find(template => template.id === this.followUp.FUS_template_id);
      return (template) ? template.label : "Sequence no longer exist.";
    },
    statusLabel() {
      return this.$utils.newGetEnumLabel(this.followUp.status, ENUMS.FollowUpSequenceStatusEnum)
    },
    title() {
      return this.templateLabel + " (" + this.statusLabel + ")";
    },
    subtitle() {
      if (this.isActive) return "Started " + dates.formatAsDate(this.followUp.started_at);
      if (this.isPaused) return "Paused " + dates.formatAsDate(this.followUp.paused_at);
      if (this.isCancelled) return "Canceled " + dates.formatAsDate(this.followUp.completed_at);
      if (this.isComplete) return "Completed " + dates.formatAsDate(this.followUp.completed_at);
    },
    icon() {
      if (this.isActive) return "follow-up-active";
      if (this.isPaused) return "follow-up-pause";
      if (this.isCancelled) return "follow-up-cancel";
      if (this.isComplete) return "follow-up-complete";
    },
  },
  methods: {
    viewFollowUp() {
      this.$refs.viewFollowUpModal.open();
    },
    pauseFollowUp() {
      this.isProcessing = true;

      this.$api.followUp.pause(this.followUp.id).then(() => {
        this.$buefy.toast.open({message: "Paused Sequence", type: "is-success"});
      }).finally(() => {
        this.isProcessing = false;
      });
    },
    resumeFollowUp() {
      this.isProcessing = true;

      return this.$api.followUp.resume(this.followUp.id).then(() => {
        this.$buefy.toast.open({message: "Resume Sequence", type: "is-success"});
      }).finally(() => {
        this.isProcessing = false;
      });
    },
    cancelFollowUp() {
      this.isProcessing = true;

      this.$api.followUp.cancel(this.followUp.id).then(() => {
        this.$buefy.toast.open({message: "Cancelled Sequence", type: "is-success"});
      }).finally(() => {
        this.isProcessing = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>

.fus_item--subtitle {
  font-size: 0.8rem;
}
</style>
